<template>
    <div class="vx-row">
        <div class="vx-col w-full mb-base">
            <vx-card :title="$t('Holidays') | ToUppercase">
                <vs-button class="float-left" color="success" type="filled" to="/holiday/add">{{$t('AddHoliday')}}</vs-button>

                <vs-table :noDataText="$t('NoHolidayFound')" max-items="14" pagination search :data="holidays">
                    <template slot="thead">
                        <vs-th sort-key="id">#</vs-th>
                        <vs-th sort-key="name">{{ $t("Name") }}</vs-th>
                        <vs-th sort-key="date">{{ $t("Date") }}</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <tbody>
                            <vs-tr :data="tr" :key="data[index].id" v-for="(tr, index) in data">
                                <vs-td>{{ data[index].id}}</vs-td>
                                <vs-td>{{ data[index].name}}</vs-td>
                                <vs-td>{{ data[index].date_formated}}</vs-td>
                            </vs-tr>
                        </tbody>
                    </template>
                </vs-table>
            </vx-card>
        </div>
    </div>
</template>
<script>
    export default {
        filters: {
            ToUppercase: function (value) {
                if (!value) return "";
                value = value.toString();
                return value.toUpperCase();
            },
        },
        components: {
        },
        data() {
            return {
                holidays: []
            };
        },
        methods: {
            updateHolidays() {
                this.$vs.loading();

                const thisIns = this;
                this.$http.get('/holiday/')
                .then(function (response) {
                    thisIns.holidays = response.data;
                }).catch(function () {
                    thisIns.$vs.notify({
                        text: "Napaka pri pridobivanju dnevnih poročil.",
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    })
                }).finally(function () {
                    thisIns.$vs.loading.close();
                });
            }
        },
        created() {
            this.updateHolidays();
        },
    };
</script>